import React, { FC } from 'react';
import { Button } from '@blueprintjs/core';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

type Props = {
  context: {
    onRemoveIp: (index: number) => void;
  }
} & ICellRendererParams;

const ActionCellRenderer: FC<Props> = (props: Props) => {
  const handleRemoveIp = () => {
    props.context.onRemoveIp(props.data.id);
  };

  if (!props.context.isEditing) {
    return null;
  }

  return (
    <Button icon="trash" minimal onClick={handleRemoveIp} />
  );
};

export default ActionCellRenderer;
